import UserService from '@/services/user/userService';
import FrontendService from '@/services/frontendService';
const fes = new FrontendService()
fes
const api = new UserService()
const state = {
  setores: [],
  setores_loading: false,
  // user_apps: [],
  // user_apps_loading: false,
};
const getters = {
  // StateUserApps: state => state.user_apps,
  // StateUserAppsLoading: state => state.user_apps_loading,
};
const mutations = {
  // SetUserApps(state, value){state.user_apps = value},
  // SetUserAppsLoading(state, value){state.user_apps_loading = value},
  SetSetores(state, value){state.setores = value},
  SetSetoresLoading(state, value){state.setores_loading = value},
};
const actions = {
    async GetAllLocais({commit}, params) {
      try {
        commit('SetSetoresLoading', true)
        const response = await api.get('local/all/', {...params, page_size: 1000 })
        commit('SetSetoresLoading', false)
        return response
      } catch (error) {
        commit('SetSetoresLoading', false)
        return error
      }
    },
    async GetLocais({commit}, params) {
      commit('SetSetoresLoading', true)
      try {
        const response = await api.get('local/', {...params, page_size: 1000 })
        commit('SetSetores', response.data.results)
      } catch (error) {
        commit('SetSetores', [])
        commit("setAlerts", [ error.toast_message ])
      }
      commit('SetSetoresLoading', false)
    },
    async GetSimpleUsers({commit}, params) {
      commit
      const response = await api.get('users/simpleusers/', {...params, page_size: 1000 })
      return response.data.results.map(u => {
        const { id, username, first_name, last_name, email } = u
        return { id, username, first_name, last_name, email }
      })
    },
    // async GetAuthenticatedUser() {
    //     return await api.authenticated_user()
    // },
    async RefreshAuthenticatedUser({ dispatch, commit }) {
      console.log('no refresh needed')
      dispatch, commit
      return
		// let logged = async () => await dispatch('GetAuthenticatedUser');
		// await logged().then(r => {
		// 	localStorage.setItem(fes.SESSION_USER_AUTHENTICATED, JSON.stringify(r.data))
		// 	commit("setAuthenticatedUser", r.data);
		// 	window.location.reload()
		// }).catch(e=>{
		// 	console.error('error on userStore RefreshAuthenticatedLogin', e)
		// })
	}
    // async GetUserApps({commit, dispatch, getters}) {
    //   commit('SetUserAppsLoading', true)
    //   dispatch
    //   getters
    //   try{
    //       let response = await api.user_apps()
    //       // console.log('user apps', response.data)
    //       commit('SetUserApps', response.data)
    //   }catch(error){
    //       commit("setAlerts", [ error.toast_message ])
    //   }
    //   commit('SetUserAppsLoading', false)
    // },
};
export default {
  state,
  getters,
  actions,
  mutations
};